var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-grid-rate-view"},[_c('section',_vm._l((_vm.rateItems),function(item){return _c('svg-icon',{key:item.key,staticClass:"c-rate c-rate-default",attrs:{"icon-class":item.isSelect? 'rate-select': 'rate-default'}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }